// extracted by mini-css-extract-plugin
module.exports = {"Card":"Akkredit__Card_2f6bf","Title":"Akkredit__Title_8LeWq","Text":"Akkredit__Text_1rTpL"};